import { get } from "lodash"
import { Creators as ProfileCreators } from "model/profileModal"
import createModule from "../createModule"
import { filterTrades, getTradeType, getApplyButtonEnabled, getStatus, getConstraintsAndErrors } from "./selectors"
import { getCsvRows, getFileName } from "./selectors/csv"
import { getBadges } from "./selectors/badges"
import { Creators } from "./model"
import view from "./view"

export default createModule({
  externalProps: state => ({
    account: state.global.selected.account,
    portfolioId: state.global.selected.portfolio,
  }),
  view,
  required: ["account", "portfolioId", "on"],
  mapStateToProps: (state, props) => ({
    ...get(state, "modules.optimizationTrades"),
    status: getStatus(state),
    tradeType: getTradeType(state),
    trades: filterTrades(state, props),
    fileName: getFileName(state, props),
    csvRows: getCsvRows(state, props),
    applyButtonEnabled: getApplyButtonEnabled(state, props),
    badges: getBadges(state, props),
    constraints: getConstraintsAndErrors(state),
  }),
  actions: {
    ...Creators,
    openSecurityProfile: ProfileCreators.openSecurityProfile,
    openFactorProfile: ProfileCreators.openFactorProfile,
  },
})
